import React, {Component} from 'react';
import Pagination from "react-js-pagination";
import ReactDOM from "react-dom";
import Swal from 'sweetalert2'
import {Redirect} from 'react-router-dom';
import InvalidAccessOrLogin from "../errorsPage/InvalidAccessOrLogin";


export default class HtmlTemplateList extends Component{

    constructor(props) {
        super(props);
        this.state = {
            htmplTemplateList: null,
            activeNumber:1,
            count:0,
            apiStatus: {
                isError: false,
                message: ''
            },
            showLoader:false,
            redirectToForbiddenPage: false
        }
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.fetchAllHtmlTemplates = this.fetchAllHtmlTemplates.bind(this)
    }

    componentDidMount(){
        this.fetchAllHtmlTemplates(this.state.activeNumber);
    }
    fetchAllHtmlTemplates(pageNumber){
        console.log("Inside fetchAllHtmlTemplates pageNumber ="+pageNumber);
        let activePageNumber = 0;
        if (pageNumber !== null && isNaN(pageNumber) === true)
            pageNumber.preventDefault();
        else if (pageNumber !== null && isNaN(pageNumber) === false) {
            activePageNumber = (parseInt(pageNumber + '', 10) - 1)
            console.log("set pageNumber");
            this.setState({activeNumber:pageNumber});
            console.log(this.state.activeNumber)
        }
        this.setState({showLoader:true});
        fetch(this.props.api + '/htmlTemplate?offset='+activePageNumber+"&limit="+10, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-AUTH-TOKEN': this.props.jwtToken
            }
        })
        .then(response => response.json())
        .then(json => {
            console.log("For fetchAllHtmlTemplates");
            console.log(json);
            if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                this.setState({showLoader: false});
                this.props.onLogoutClick(json.message);
            } else if (json.httpCode === 403 && json.isError === true && json.message === "Forbidden") {
                this.setState({showLoader: false, redirectToForbiddenPage: true});
            } else {
                this.setState({
                    htmplTemplateList: json.templates.content,
                    count: json.templates.totalElements,
                    activeNumber: pageNumber
                });
                this.setState({showLoader: false});
            }
        }).catch(error =>{
            console.log(error);
            this.setState({showLoader:false});
        });
    }

    handleKeyPress(id,e) {
        if (!e.shiftKey){
            const domForm = ReactDOM.findDOMNode(e).childNodes[0].getElementsByClassName(id);
            const domFormSubmit = domForm.item(0);
            console.log(domFormSubmit);
            if(domFormSubmit){
                domFormSubmit.submit()
            }
        }
    }
    handleDeleteHtmlTemplate(htmlTemplateId, pageNumber, count){
        console.log("Inside handleDeleteSignatureId "+htmlTemplateId);
        console.log("htmlTemplateId="+htmlTemplateId+", pageNumber="+pageNumber+", count="+count);
        let url = this.props.api+'/htmlTemplate/'+htmlTemplateId+'?offset='+pageNumber+'&max='+count;
        console.log("url--- "+url);
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this template!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it'
        }).then((result) => {
            if (result.value) {
                this.setState({showLoader:true});
                fetch(url, {
                    method: 'delete',
                    mode: 'cors',
                    headers: {
                        'X-AUTH-TOKEN': this.props.jwtToken
                    }
                })
                .then(response => response.json())
                .then(json => {
                    console.log("Deleting Details");
                    console.log(json);
                    if (json && json.isError === false){
                        const {apiStatus}  = this.state;
                        apiStatus.isError = false;
                        apiStatus.message = json.message;
                        this.setState({ apiStatus: apiStatus})
                        console.log("apiStatus.message"+this.state.apiStatus.message);
                        this.fetchAllHtmlTemplates(json.offset)
                        this.setState({showLoader:false});
                    }else{
                        const {apiStatus}  = this.state;
                        apiStatus.isError = true;
                        apiStatus.message = json.messages;
                        this.setState({disabledButton: true, apiStatus: apiStatus});
                        this.setState({showLoader:false});
                        if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                            this.props.onLogoutClick(json.message);
                        }
                    }

                }).catch(error => {
                    this.setState({showLoader:false});
                    console.log(error);
                });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
            }
        })
    }
    refreshPageData(event) {
        this.setState({htmplTemplateList: null});
        this.setState({activeNumber: 1});
        this.setState({ count:0});
        this.setState({    apiStatus: {
                isError: false,
                message: ''
            }});
        this.setState({showLoader:false});
        this.componentDidMount()
    }
    render() {
        let _this = this;
        return(
            <div className="wrapper animated fadeInRight">
                <InvalidAccessOrLogin jwtToken={this.props.jwtToken}
                                      redirectToForbiddenPage={this.state.redirectToForbiddenPage}/>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="dashboard-table-wrap">
                            {/*<div className="ibox-content">*/}
                            <div className="heading-wrapper clearfix">
                                <p className="m-t-xs">{_this.props.msg('htmlTemplatesList.header1')}</p>
                                <div className="pull-right text-right" style={{position:'relative'}}>
                                    {_this.props.authentication && _this.props.authentication.roles &&_this.props.authentication.roles.includes('ROLE_SYSTEM_SUPPORT')?
                                    <form action={_this.props.backEndServerUrl+'/login/authenticateByToken'} method="post" style={{marginRight:'85px'}}>
                                        <input type="hidden" name="token" value={this.props.jwtToken} />
                                        <input type="hidden" name="pageUrl" value="/esignature/createHtmlTemplate" />
                                        <input type="hidden" name="erpRequest" value="true" />
                                        <input type="submit" value={_this.props.msg('htmlTemplatesList.button.add')} className="btn btn-primary" name="Add New Template"/>
                                    </form>:''}

                                <div className="search-wrap" style={{position:'absolute', right:'0', top:'3px'}}>
                                    <button type="button" className="btn btn-white btn-sm" style={{marginRight: '10px'}} onClick={ this.refreshPageData.bind(this) }>{_this.props.msg('htmlTemplatesList.button.refresh')}</button>
                                </div>
                                </div>
                            </div>
                                {this.state.showLoader === true ? (<div className="loading">Loading&#8230;</div>) : ''}
                                <div className="table-box table-responsive p-m">
                                    <div style={{'textAlign':'center'}}>
                                    <span
                                    style={{'color':this.state.apiStatus.isError===true?'red':'green'}}> {this.state.apiStatus.message ? this.state.apiStatus.message : ''}</span>
                                        <br/>
                                    </div>
                                    <table className="table table-condensed-xs" >
                                        <thead>
                                        <tr>
                                            <th>{_this.props.msg('table.th.name')}</th>
                                            <th>{_this.props.msg('table.th.description')}</th>
                                            {_this.props.authentication && _this.props.authentication.roles && _this.props.authentication.roles.includes('ROLE_SYSTEM_SUPPORT')?
                                            <th>{_this.props.msg('table.th.action')}</th>:''}
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.htmplTemplateList && this.state.htmplTemplateList.map(function(template, index){
                                            return (
                                                <tr key={Math.random()}>
                                                    <td className="center" >{template.templateName}</td>
                                                    <td className="center">{template.description}</td>
                                                    {_this.props.authentication && _this.props.authentication.roles && _this.props.authentication.roles.includes('ROLE_SYSTEM_SUPPORT')?
                                                    <td className="center">
                                                        <form ref="form"
                                                              className={'m-r-xxs '+template.id}
                                                              style={{display:'inline-block'}}
                                                            action={_this.props.backEndServerUrl+'/login/authenticateByToken'} method="post" >
                                                            <input type="hidden" name="token" value={_this.props.jwtToken} />
                                                            <input type="hidden" name="pageUrl" value={'/esignature/createHtmlTemplate?id='+template.id} />
                                                            <input type="hidden" name="erpRequest" value="true" />
                                                            <button type="submit" onClick={(e)=>_this.handleKeyPress(template.id,_this)}  title="Edit" className="btn btn-white btn-sm" >
                                                                <i className="fa fa-edit"></i>
                                                                <span className="hidden-xs hidden-sm"> Edit</span>
                                                            </button>
                                                        </form>
                                                        <button type="button" onClick={(e)=>_this.handleDeleteHtmlTemplate(template.id, _this.state.activeNumber, _this.state.count)} className="btn btn-white btn-sm m-r-xxs" title="Delete">
                                                            <i className="fa fa-trash"></i>
                                                            <span className="hidden-xs hidden-sm"> Delete</span>
                                                        </button>
                                                    </td>:''}
                                                </tr>
                                            );
                                        })}
                                        </tbody>
                                        <tfoot>
                                        <tr>
                                            <td colSpan="6" className="footable-visible">
                                    <Pagination
                                        activePage={this.state.activeNumber}
                                        itemsCountPerPage={10}
                                        totalItemsCount={this.state.count}
                                        pageRangeDisplayed={5}
                                        onChange={this.fetchAllHtmlTemplates}
                                    />
                                            </td>
                                        </tr>
                                        </tfoot>
                                    </table>
                                {/*</div>*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/template/HtmlTemplateList.js